
export default {
    data: () => ({
        partnerCodes: {
            hr_co: 'hr_co',
        }
    })
}
